import { tv } from 'tailwind-variants';

const sidebarVariants = tv({
  slots: {
    container: 'bg-white flex flex-col gap-2 h-full w-[260px] shrink-0',
    border: 'border-[#e0e0e0]',
    header: 'flex items-center px-8 py-3 w-full',
    headerText:
      'font-semibold text-[14px] leading-[18px] text-[#161616] tracking-[0.16px]',
    navSection: 'flex flex-col w-full',
    navItem:
      'flex items-center h-8 pl-6 pr-0 py-1 w-full cursor-pointer transition-colors',
    navText:
      'font-normal text-[14px] leading-[18px] text-[#161616] tracking-[0.16px]',
  },
  variants: {
    navItemType: {
      selected: {
        navItem: 'bg-[#edf5ff]',
        navText: 'font-semibold',
      },
      default: {
        navItem: 'hover:bg-[#f9f9fa]',
      },
    },
  },
});

type SidebarNavigationProps = {
  selectedItem?: string;
  onItemSelect?: (item: string) => void;
};

export const SidebarNavigation = ({
  selectedItem = 'project',
  onItemSelect,
}: SidebarNavigationProps) => {
  const {
    container,
    border,
    header,
    headerText,
    navSection,
    navItem,
    navText,
  } = sidebarVariants();

  const navItems = [
    { id: 'project', label: 'Project' },
    { id: 'account', label: 'Account' },
    { id: 'contact', label: 'Contact' },
  ];

  const handleItemClick = (itemId: string) => {
    onItemSelect?.(itemId);
  };

  return (
    <div className={container()}>
      <div aria-hidden="true" className={border()} />

      <div className={header()}>
        <span className={headerText()}>Objects</span>
      </div>

      <div className={navSection()}>
        {navItems.map((item) => (
          <div
            key={item.id}
            className={navItem({
              navItemType: selectedItem === item.id ? 'selected' : 'default',
            })}
            onClick={() => handleItemClick(item.id)}
          >
            <span
              className={navText({
                navItemType: selectedItem === item.id ? 'selected' : 'default',
              })}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
